import {Outlet} from "react-router-dom";
import React, {useEffect, useState} from "react";
import fondo from "./assets/fondo.png"
import logo from "../../assets/cuentas/logo-png.webp"
import howToCel from "./assets/banne-mobile.jpg"
import howToPc from "./assets/banner-pc.jpg"

import {Box, Button, Card, Center} from "@chakra-ui/react";

const setBackground = () => {

  // Create our stylesheet
  const style = document.createElement('style')
  style.innerHTML =
    `body {
      background-image: url("${fondo}");
     -webkit-background-size: cover;
     -moz-background-size: cover;
     -o-background-size: cover;
     background-size: cover;
      background-repeat: no-repeat; 
  background-attachment: fixed;    
  }
  
   @media screen and (max-width: 815px) {
   
      body {
      } 
   }
  `

// Get the first script tag
  const ref = document.getElementById('root')

// Insert our new styles before the first script tag
  ref.parentNode.insertBefore(style, ref)
}

const LayoutDisney = () => {

  const [ready, setReady] = useState(false)
  useEffect(() => {
    document.title = 'Tienda Digital Netflix'
    setBackground()
  }, []);

  if (!ready) {
    return (
      <Box>
        <Center>
          <Box hideBelow='lg' paddingTop={10} paddingX={40}>
            <img src={howToPc}/>
          </Box>
          <Box hideFrom={'lg'} paddingTop={10} paddingX={10}>
            <img src={howToCel}/>
          </Box>

        </Center>
        <Center>
          <Box paddingY={7} display={'block'}>
            <Button onClick={() => setReady(true)} paddingX={20}>Continuar</Button>
          </Box>
        </Center>
      </Box>
    )
  }
  return (
    <>
      <Center>
        <Box w={['95%', '80%', 700]} pt={50}>
          <Center> <img src={logo}/>
          </Center>
          <Card
            boxShadow='dark-lg'
            border={'1px'}
            borderColor={'#FFFFFF'}
            color={'#FFFFFF'}
            background={'rgba(76, 135, 139, 0.5)'}
          >

            <Outlet/>
          </Card>
        </Box>
      </Center>
      <Center mt={3} color={'#FFFFFF'}>
        Este producto se vende por pantallas. No se entrega usuario ni contraseña. La activación de la pantalla se
        realiza mediante este enlace, lo que garantiza su uso en un solo dispositivo
      </Center>
      {/*
        <Center>
        <img src={bannerTop5} width={200}/>
      </Center>
      <SimpleGrid columns={[2, 2, 3, 5]} spacing={10}>
        <img src={top1}/>
        <img src={top2}/>
        <img src={top3}/>
        <img src={top4}/>
        <img src={top5}/>
      </SimpleGrid>
      */}
    </>
  );

}

export default LayoutDisney
